import {
    AppBar,
    Box,
    Container,
    useTheme,
    Typography,
    Grid
} from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";

import { useTypedSelector } from "../../hooks/useTypedSelector";
import { useActions } from "../../hooks/useActions";

import LinkRouter from "../../components/LinkRouter";

import { logo } from "../../assets/logos";
import { SelectedTypographyStyle, TypographyStyle } from "../DefaultLayout/styled";


interface IAppBarItem {
    lable: string,
    path: string,
}

const Header = () => {
    const { palette } = useTheme();
    const location = useLocation();

    const { DeleteAnnouncementImages } = useActions();
    const { uploadedImages } = useTypedSelector((store) => store.announcement);

    const navigate = useNavigate();

    const [pages, setPages] = useState<Array<IAppBarItem>>([
        { lable: 'Анонси', path: '/admin' },
        { lable: 'Проєкти', path: '/admin/projects' },
        { lable: 'Теги', path: '/admin/hashtags' },
        { lable: 'Фото звітів', path: '/admin/reporting-images' },
    ]);

    const handleUnload = () => {
        try {
            DeleteAnnouncementImages(uploadedImages);
        }
        catch (ex) {
        }
    }

    return (
        <AppBar component="header" elevation={0} position="static" sx={{ height: "64px", borderBottom: (theme) => `1px solid ${theme.palette.primary.light}` }}>
            <Container sx={{ height: "100%", maxWidth: { lg: "1310px", md: "744px", xs: "364px" } }}>
                <Grid container spacing={0} sx={{ height: "100%", display: "flex", alignItems: "center" }}>
                    <Grid item xs={2}>
                        <LinkRouter underline="none" color="unset" to="/" sx={{ display: "flex", width: "200px", height: "34px" }} >
                            <img
                                onClick={() => handleUnload()}
                                loading="eager"
                                style={{ width: "inherit", height: "inherit" }}
                                src={logo}
                                alt="logo"
                            />
                        </LinkRouter>
                    </Grid>
                    <Grid item xs={2} />
                    <Grid item xs={4} sx={{ display: 'flex', justifyContent: "space-between" }}>
                        {pages.map((page, index) => (
                            <LinkRouter key={index} underline={"none"} color={"inherit"} to={page.path} >
                                {(location.pathname == page.path)
                                    ? <SelectedTypographyStyle onClick={() => handleUnload()}>
                                        {page.lable}
                                    </SelectedTypographyStyle>
                                    : <TypographyStyle onClick={() => handleUnload()}>
                                        {page.lable}
                                    </TypographyStyle>
                                }
                            </LinkRouter>
                        ))}
                    </Grid>
                    <Grid item xs={4} />

                </Grid>
            </Container>
        </AppBar >
    );
};

export default Header;